/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolAirportShuttleIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-airport-shuttle"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M5.92 19.35Q5.92 19.35 5.25 19.35Q4.58 19.35 3.65 18.43Q2.73 17.5 2.73 16.15L2.73 16.15Q1.85 16.15 1.24 15.54Q0.63 14.93 0.63 14.05L0.63 7.15Q0.63 6.03 1.39 5.26Q2.15 4.5 3.27 4.5L16.02 4.5Q16.55 4.5 17.04 4.7Q17.52 4.9 17.9 5.28L22.6 10.03Q22.98 10.4 23.18 10.89Q23.38 11.38 23.38 11.9L23.38 14Q23.38 14.88 22.74 15.51Q22.1 16.15 21.23 16.15L21.23 16.15Q21.23 17.5 20.3 18.43Q19.38 19.35 18.02 19.35Q16.68 19.35 15.75 18.43Q14.82 17.5 14.82 16.15L9.13 16.15Q9.13 17.5 8.2 18.43Q7.28 19.35 5.92 19.35ZM15.07 9.7L18.88 9.7L15.97 6.75Q15.97 6.75 15.97 6.75Q15.97 6.75 15.97 6.75L15.07 6.75ZM9.13 9.7L12.82 9.7L12.82 6.75L9.13 6.75ZM2.88 9.7L6.88 9.7L6.88 6.75L2.88 6.75Q2.88 6.75 2.88 6.75Q2.88 6.75 2.88 6.75ZM5.92 17.4Q5.92 17.4 6.19 17.4Q6.45 17.4 6.81 17.04Q7.17 16.68 7.17 16.15Q7.17 15.63 6.81 15.26Q6.45 14.9 5.92 14.9Q5.4 14.9 5.04 15.26Q4.67 15.63 4.67 16.15Q4.67 16.68 5.04 17.04Q5.4 17.4 5.92 17.4ZM18.02 17.4Q18.02 17.4 18.29 17.4Q18.55 17.4 18.91 17.04Q19.27 16.68 19.27 16.15Q19.27 15.63 18.91 15.26Q18.55 14.9 18.02 14.9Q17.5 14.9 17.14 15.26Q16.77 15.63 16.77 16.15Q16.77 16.68 17.14 17.04Q17.5 17.4 18.02 17.4Z" fill={color} />
    </svg>
  );
}
